$(document).ready(function () {

    $('.menu-btn').click(function () {
        var overlay_navigation = $('.overlay-navigation'),
            nav_item_1 = $('nav li:nth-of-type(1)'),
            nav_item_2 = $('nav li:nth-of-type(2)'),
            nav_item_3 = $('nav li:nth-of-type(3)'),
            nav_item_4 = $('nav li:nth-of-type(4)'),
            nav_item_5 = $('nav li:nth-of-type(5)'),
            nav_item_6 = $('nav li:nth-of-type(6)');

        overlay_navigation.toggleClass('overlay-active');
        if (overlay_navigation.hasClass('overlay-active')) {

            $('.menu-btn').addClass('active');
            overlay_navigation.removeClass('overlay-slide-up').addClass('overlay-slide-down');
            nav_item_1.removeClass('slide-in-nav-item-reverse').addClass('slide-in-nav-item');
            nav_item_2.removeClass('slide-in-nav-item-delay-1-reverse').addClass('slide-in-nav-item-delay-1');
            nav_item_3.removeClass('slide-in-nav-item-delay-2-reverse').addClass('slide-in-nav-item-delay-2');
            nav_item_4.removeClass('slide-in-nav-item-delay-3-reverse').addClass('slide-in-nav-item-delay-3');
            nav_item_5.removeClass('slide-in-nav-item-delay-4-reverse').addClass('slide-in-nav-item-delay-4');
            nav_item_6.removeClass('slide-in-nav-item-delay-5-reverse').addClass('slide-in-nav-item-delay-5');
        } else {
            $('.menu-btn').removeClass('active');
            overlay_navigation.removeClass('overlay-slide-down').addClass('overlay-slide-up');
            nav_item_1.removeClass('slide-in-nav-item').addClass('slide-in-nav-item-reverse');
            nav_item_2.removeClass('slide-in-nav-item-delay-1').addClass('slide-in-nav-item-delay-1-reverse');
            nav_item_3.removeClass('slide-in-nav-item-delay-2').addClass('slide-in-nav-item-delay-2-reverse');
            nav_item_4.removeClass('slide-in-nav-item-delay-3').addClass('slide-in-nav-item-delay-3-reverse');
            nav_item_5.removeClass('slide-in-nav-item-delay-4').addClass('slide-in-nav-item-delay-4-reverse');
            nav_item_6.removeClass('slide-in-nav-item-delay-5').addClass('slide-in-nav-item-delay-5-reverse');
        }
    });
    /*appear after scroll*/

    //sticky nav
    var $window;

    function stickyNavigation() {
        var $this = $(this),
            navScrolled = "sticky",
            siteHeader = $('.main_header').height(),
            navbar = $('.main_header');

        if ($this.scrollTop() > siteHeader + 50) {
            navbar.addClass(navScrolled);
        } else {
            navbar.removeClass(navScrolled);
        }
    }

    $(function () {
        var $window = $(window);

        $window.scroll(stickyNavigation);
    });
    
    
    // tabs
    $('.tabs-nav a').on('click', function (event) {
        event.preventDefault();

        $('.tab-active').removeClass('tab-active');
        $(this).parent().addClass('tab-active');
        $('.tabs-stage div').hide();
        $($(this).attr('href')).show();
    });

    $('.tabs-nav a:first').trigger('click'); // Default
    
   
});